import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'belender-widget-logo',
  templateUrl: './widget-logo.component.html',
  styleUrls: ['./widget-logo.component.scss']
})
export class WidgetLogoComponent implements OnInit {
  @Input() logoUrl: string = '';
  @Input() firstOption: string = this.logoUrl;
  @Input() withLogo: boolean = false;
  logoUrlIsLoaded: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  // Mostramos el logo si est\u00e1 activado withLogo, o si hay una imagen
  // personalizada (firstOption) aunque withLogo venga en false/0.
  get shouldShow(): boolean {
    return !!this.withLogo || !!this.firstOption;
  }

}